import classNames from 'classnames';
// import { Col, Row } from 'react-bootstrap';

interface FooterProps {
  className?: string;
}

const Footer = ({ className }: FooterProps) => {
  return (
    <footer
      className={classNames(className, 'footer bg-body-emphasis')}
    ></footer>
  );
};

export default Footer;
